module.exports = __webpack_public_path__ + "img/configure.9e133b10.svg";